const nameData = "datos"; // Define la entidad dinámica
const nameDataSingular = "visita"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData, searchCli, searchEmp, dateFrom, dateUntil, hourFrom, hourUntil, tienePedido, numPagina, filas) => {
  try {
    const data = await getEntityPanelData(searchEmp, searchCli, dateFrom, dateUntil, hourFrom, hourUntil, tienePedido, numPagina, filas);
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      return {
        dataEntity: data[nameData] || [], // Usa nameData dinámicamente
        totalItems: data.pagination.totalItems || 0,
        totalPage,
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};
export const fetchEntityPrintData = async (getEntityPanelData, searchCli, searchEmp, dateFrom, dateUntil, hourFrom, hourUntil, tienePedido) => {
  try {
    const data = await getEntityPanelData(searchEmp, searchCli, dateFrom, dateUntil, hourFrom, hourUntil, tienePedido,1, 2000);
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      return {
        dataEntity: data[nameData] || [], 
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

export const fetchEntityRoutesData = async (getEntityPanelData, searchEmp, dateSelected, hourFrom, hourUntil,) => {
  try {
    const data = await getEntityPanelData(searchEmp, dateSelected, hourFrom, hourUntil);
    if (data) {
      return {
        dataEntity: data[nameData] || [], 
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
